import React from "react";
import { Space, Typography } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import Card from "../card/Card";

const { Text } = Typography;

const ProjectModules = ({ onModuleClick }) => {
  const modules = [
    {
      key: "sync",
      name: "SYNC",
      description: "Integrações ERP",
      backgroundColor: "#e6f7ff",
      borderColor: "#91d5ff",
      iconColor: "#1890ff",
      enabled: true,
      letter: "S",
    },
    {
      key: "reports",
      name: "REPORTS",
      description: "Relatórios Analytics",
      backgroundColor: "#f6ffed",
      borderColor: "#b7eb8f",
      iconColor: "#52c41a",
      enabled: true,
      letter: "R",
    },
    {
      key: "flow",
      name: "FLOW",
      description: "Fluxos de Trabalho",
      backgroundColor: "#f9f0ff",
      borderColor: "#d3adf7",
      iconColor: "#722ed1",
      enabled: false,
      letter: "F",
    },
  ];

  const handleModuleClick = (module) => {
    if (module.enabled && onModuleClick) {
      onModuleClick(module.key);
    }
  };

  return (
    <Card
      title={
        <span style={{ fontSize: 16, fontWeight: 600 }}>
          Acesso Rápido aos Módulos
        </span>
      }
      style={{ marginBottom: 24 }}
    >
      <Space direction="vertical" size={12} style={{ width: "100%" }}>
        {modules.map((module) => {
          const isDisabled = !module.enabled;
          return (
            <div
              key={module.key}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: 16,
                backgroundColor: module.backgroundColor,
                borderRadius: 8,
                cursor: isDisabled ? "not-allowed" : "pointer",
                border: `1px solid ${module.borderColor}`,
                opacity: isDisabled ? 0.5 : 1,
                filter: isDisabled ? "blur(0.2px) grayscale(0.1)" : "none",
                pointerEvents: isDisabled ? "none" : "auto",
                transition: "all 0.2s ease",
              }}
              onClick={() => handleModuleClick(module)}
              data-tour-id={`module-${module.key}`}
              onMouseEnter={(e) => {
                if (!isDisabled) {
                  e.currentTarget.style.transform = "translateY(-1px)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isDisabled) {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }
              }}
            >
              <Space size={12}>
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 8,
                    backgroundColor: module.iconColor,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    fontSize: 18,
                    fontWeight: "bold",
                  }}
                >
                  {module.letter}
                </div>
                <div>
                  <Text
                    style={{
                      fontSize: 14,
                      fontWeight: 600,
                      display: "block",
                      color: isDisabled ? "#bfbfbf" : undefined,
                    }}
                  >
                    {module.name}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      color: isDisabled ? "#111111ff" : "#333333ff",
                      display: "block",
                    }}
                  >
                    {isDisabled ? "Em breve" : module.description}
                  </Text>
                </div>
              </Space>
              {!isDisabled && (
                <ArrowRightOutlined style={{ color: module.iconColor }} />
              )}
            </div>
          );
        })}
      </Space>
    </Card>
  );
};

export default ProjectModules;
